import { container } from './container';
import { CONTEXT_SOURCE, SYNC_CONTEXT_SOURCE } from './const';
/**
 * 执行器
 */
class Actuator {
  constructor() {
    this.execPromise = Promise.resolve();
  }
  /**
   * 执行操作
   * @param actionName 操作名称
   * @param args 操作参数
   */
  execute(id, methodName, args) {
    const context = container.get(id);
    const syncContext = container.get(SYNC_CONTEXT_SOURCE);
    if (context) {
      let fn = context[methodName];
      const execTime = fn.execTime;
      const action = () => {
        syncContext.setContextSource(CONTEXT_SOURCE.REMOTE);
        let result = fn.apply(context, args);
        syncContext.setContextSource(CONTEXT_SOURCE.LOCAL);
        return result;
      };
      if (execTime) {
        this.execPromise = this.execPromise.then(function () {
          return new Promise(function (resolve) {
            action();
            setTimeout(resolve, execTime);
          });
        });
      } else {
        this.execPromise = this.execPromise.then(function () {
          return Promise.resolve(action());
        });
      }
      this.execPromise.catch(function (ex) {
        console.error(ex);
      });
    }
  }
}
export { Actuator };
